import { Satisfaction } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { languages } from 'app/utils/supportedLanguages';

import satisfactionActions from '../../../actions/satisfaction';
import {
  DispatchProps,
  DixaMessengerPanel,
  StateProps,
} from '../../../components/sections/satisfaction/components/DixaMessengerCSAT/Panel/DixaMessengerPanel';
import { DixaMessengerCSAT } from '../../../components/sections/satisfaction/components/DixaMessengerCSAT/page/types';

const mapStateToProps = (state: RootReducerStateT): StateProps => ({
  globalSettings: {
    asyncStatus:
      state.settings.satisfaction.customization.messenger.globalLevel
        .asyncStatus,
    values:
      state.settings.satisfaction.customization.messenger.globalLevel.values,
  },

  contactPointSettings: {
    asyncStatus:
      state.settings.satisfaction.customization.messenger.contactPointsLevel
        .asyncStatus,
    list:
      state.settings.satisfaction.customization.messenger?.contactPointsLevel
        .values || [],
  },

  languagesSettings: {
    asyncStatus:
      state.settings.satisfaction.customization.email.languagesLevel
        .asyncStatus,
    list: languages.map(({ code, label }) => {
      const correspondingSettings =
        state.settings.satisfaction.customization.messenger.languagesLevel.values?.find(
          ({ language }) => language === code,
        );

      if (correspondingSettings) {
        return { code, label, settings: correspondingSettings };
      }

      return { code, label, settings: null };
    }),
  },
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return {
    loadDixaMessengerSettingsAllLevels() {
      dispatch(
        satisfactionActions.satisfactionLoadDixaMessengerAllLevelsSettingsRequest(),
      );
    },
    initializeDixaMessengerCsat() {
      dispatch(satisfactionActions.satisfactionInitializeRequest('messenger'));
    },
    createGlobalSettings: (
      settings: Satisfaction.CreateDixaMessengerCsatSettingsParams,
    ) => {
      dispatch(
        satisfactionActions.satisfactionSaveDixaMessengerGlobalSettingsRequest(
          settings,
          { edit: false },
        ),
      );
    },
    updateGlobalSettings: (
      settings: Satisfaction.UpdateDixaMessengerCsatSettingsParams,
    ) => {
      dispatch(
        satisfactionActions.satisfactionSaveDixaMessengerGlobalSettingsRequest(
          settings,
          { edit: true },
        ),
      );
    },
    updateContactPointLevelSettings: ({
      settings,
      ...change
    }: DixaMessengerCSAT.MessengerStatusChange) => {
      dispatch(
        satisfactionActions.satisfactionSaveDixaMessengerContactLevelSettingsRequest(
          change,
          settings,
        ),
      );
    },
    updateLanguageLevelSettings(
      payload: Partial<Satisfaction.DixaMessengerCsatSettings>, // payload: Partial<Satisfaction.DixaMessengerCsatSettings>,
    ) {
      const action =
        satisfactionActions.satisfactionSaveDixaMessengerLanguageLevelSettingsRequest(
          payload,
        );
      dispatch(action);
    },
  };
};

export const SatisfactionDixaMessengerPanel = connect<
  StateProps,
  DispatchProps,
  Record<string, unknown>,
  RootReducerStateT
>(
  mapStateToProps,
  mapDispatchToProps,
)(DixaMessengerPanel);
